import React from 'react';
import Carousel from './Carousel';

const PUBLIC_URL = process.env.PUBLIC_URL;
const slideTexts = [
  { title: 'Assessoria Completa', text: 'Assessoria especializada desde o planejamento até a entrega' },
  { title: 'Direto de Fábrica', text: 'Custos reduzidos com compra direta de fábrica' },
  { title: 'Qualidade e Resistência', text: 'Durabilidade e resistência para uso intenso no dia a dia' },
  { title: 'Entrega em Todo o Brasil', text: 'Logística eficiente para todo o Brasil' },
  { title: 'Projetos Sob Medida', text: 'Soluções sob medida para cada tipo de ambiente' }
];

const TOTAL_IMAGES = 16;
const numTexts = slideTexts.length;
const slides = Array.from({ length: TOTAL_IMAGES }, (_, index) => {
  const imageId = index + 1;
  const textData = slideTexts[index % numTexts];

  return {
    id: imageId,
    image: `${PUBLIC_URL}/images/fotos/${imageId}.png`,
    title: textData.title,
    text: textData.text
  };
});

const Hero = () => {
  return (
    <div className="hero">
      <Carousel slides={slides} />
    </div>
  );
};

export default Hero;